import { render, staticRenderFns } from "./AccesDenied.vue?vue&type=template&id=bd4797d2&"
import script from "./AccesDenied.vue?vue&type=script&lang=js&"
export * from "./AccesDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports